
import { ISsrConfigService } from "./ISsrConfigService";
import { BlindConfigService } from "../Common/BlindConfigurations/BlindConfigService";

export class SsrConfigService extends BlindConfigService implements ISsrConfigService {
    public static readonly ServiceName: string = "SsrConfigService";

    constructor() {
        super();
    }

    GetServiceName(): string {
        return SsrConfigService.ServiceName;
    }
}
